const Router = {
  MAIN: "/*",
  // HOME: "/",
  LOGIN: "/",
  
  //---------------- Admin ROUTES ---------------------
  ADMIN_DASHBOARD: "/admin_portal",
  ADMIN_USER: "/admin_portal/user",
  ADMIN_DID_TFN_NUMBER: "/admin_portal/did_tfn_number",
  ADMIN_REPORT: "/admin_portal/report",
  ADMIN_EXTENSION: "/admin_portal/extension",
  ADMIN_CALL_ACTIVE: "/admin_portal/call_actv",
  ADMIN_QUEUE_CALLS:"/admin_portal/queue_call",
  ADMIN_CALL_BLOCK:"/admin_portal/call_block",
  ADMIN_SERVER_STATS: "/admin_portal/server_stats",
  ADMIN_QUEUE: "/admin_portal/queue",
  ADMIN_QUEUE_MEMBER: "/admin_portal/queue_member",
  ADMIN_MINUTES: "/admin_portal/minutes",
  ADMIN_BILLING_MINUTES: "/admin_portal/billing_minutes",
  ADMIN_MDR: "/admin_portal/mdr",
  ADMIN_HISTORY: "/admin_portal/history",
  ADMIN_QUEUE: "/admin_portal/queue",
  ADMIN_AUDIT_LOGS: "/admin_portal/audit_logs",
  ADMIN_PORTAL_AUDIT_LOGS: "/admin_portal/portal_audit_logs",
  ADMIN_DID_CARRIER: "/admin_portal/did_carrier",
  ADMIN_RECORDING: "/admin_portal/recording",
  ADMIN_CARRIER: "/admin_portal/carrier",
  ADMIN_VIEW: "/admin_portal/profile",
  ADMIN_LIVE_EXTENSION: "/admin_portal/live_extension",
  ADMIN_IVR_UPLOADS:"/admin_portal/ivr_uploads",
  AdminMOH:"/admin_portal/moh",
  ADMIN_ACL: "/admin_portal/acl",
  ADMIN_ACL_HISTORY: "/admin_portal/acl_history",
  ADMIN_PERMISSIONS_ACCESS:"/admin_portal/permissions",
  ADMIN_TFN_ASSISTANT:"/admin_portal/assistant",
  ADMIN_INVOICE: "/admin_portal/invoice",
  ADMIN_PRODUCT: "/admin_portal/product",
  ADMIN_MANAGE_CAMPAIGN: "/admin_portal/manage_campaign",
  ADMIN_BUYER: "/admin_portal/viewbuyer",
  ADMIN_PROMOTION: "/admin_portal/promotion",
  ADMIN_CMU: "/admin_portal/cmu",
  ADMIN_ROLES: "/admin_portal/roles",
  ADMIN_SIP_TRACER: "/admin_portal/sip_tracer",

   //---------------- Reseller ROUTES ---------------------
   RESELLER_DASHBOARD: "/reseller_portal",
   RESELLER_USER: "/reseller_portal/user",
   RESELLER_MANAGE_CAMPAIGN: "/reseller_portal/manage_campaign",
   RESELLER_DID_TFN_NUMBER: "/reseller_portal/did_tfn_number",
   RESELLER_REPORT: "/reseller_portal/report",
   RESELLER_EXTENSION: "/reseller_portal/extension",
   RESELLER_CALL_ACTIVE: "/reseller_portal/call_actv",
   RESELLER_QUEUE_CALLS:"/reseller_portal/queue_call",
   RESELLER_CALL_BLOCK:"/reseller_portal/call_block",
   RESELLER_SERVER_STATS: "/reseller_portal/server_stats",
   RESELLER_QUEUE: "/reseller_portal/queue",
   RESELLER_QUEUE_MEMBER: "/reseller_portal/queue_member",
   RESELLER_MINUTES: "/reseller_portal/minutes",
   RESELLER_BILLING_MINUTES: "/reseller_portal/billing_minutes",
   RESELLER_MDR: "/reseller_portal/mdr",
   RESELLER_HISTORY: "/reseller_portal/history",
   RESELLER_QUEUE: "/reseller_portal/queue",
   RESELLER_AUDIT_LOGS: "/reseller_portal/audit_logs",
   RESELLER_RECORDING: "/reseller_portal/recording",
   RESELLER_CARRIER: "/reseller_portal/carrier",
   RESELLER_VIEW: "/reseller_portal/profile",
   RESELLER_LIVE_EXTENSION: "/reseller_portal/live_extension",
   RESELLER_IVR_UPLOADS:"/reseller_portal/ivr_uploads",
   RESELLER_MOH:"/reseller_portal/reseller_moh",
   RESELLER_ACL: "/reseller_portal/reseller_acl",
   RESELLER_PERMISSIONS_ACCESS:"/reseller_portal/permissions",
   RESELLER_TFN_ASSISTANT:"/reseller_portal/reseller_assistant",

  //------------------Redirect Routes------------------
  REDIRECT_DASHBOARD: "/redirect_portal",
  REDIRECT_BLOG: "/redirect_portal/blogs",
  REDIRECT_XML_CDR: "/redirect_portal/xml_cdr",
  REDIRECT_CALL_ACTIVE: "/redirect_portal/call_active",
  REDIRECT_CALL_BLOCK: "/redirect_portal/call_block",
  REDIRECT_CAMPAIGNS: "/redirect_portal/campaigns",
  REDIRECT_BUYER_VIEW: "/redirect_portal/buyer_view",
  REDIRECT_DESTINATION: "/redirect_portal/destination",
  REDIRECT_MINUTES_LOG: "/redirect_portal/minute_logs",
  REDIRECT_ACTIVITY_LOG: "/redirect_portal/activity_log",

};

export default Router;
